export default __webpack_public_path__ + "static/media/shape_2.debf76d6.svg";